import { render, staticRenderFns } from "./BigLoader.vue?vue&type=template&id=2736e766&scoped=true&"
import script from "./BigLoader.vue?vue&type=script&lang=ts&"
export * from "./BigLoader.vue?vue&type=script&lang=ts&"
import style0 from "./BigLoader.vue?vue&type=style&index=0&id=2736e766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2736e766",
  null
  
)

export default component.exports